import { ShortCode } from '@highereducation/wordpress';
import { PageSection } from '@highereducation/hen-ui';

type PageSectionShortcodeProps = {
  title: string;
  subtitle: string;
  variant?: 'light' | 'white-outline';
  alignment?: 'center' | 'left' | 'right';
  children?: React.ReactNode;
};

export const PageSectionShortcode: ShortCode<PageSectionShortcodeProps> = {
  component: ({
    title,
    subtitle,
    variant = 'light',
    alignment = 'center',
    children,
  }) => {
    return (
      <PageSection
        title={title}
        subtitle={subtitle}
        variant={variant}
        alignment={alignment}
      >
        {children}
      </PageSection>
    );
  },
};
